module.exports = __webpack_public_path__ + "static/media/gov-logo-text-black.3f35c591.svg";